@defer (on hover) {
  <div
    nz-tooltip
    [nzTooltipTitle]="tooltip"
    nzTooltipColor="#fff"
    class="kpi-parent-container"
  >
    <ng-container *ngTemplateOutlet="kpiValue"></ng-container>
  </div>
} @placeholder {
  <div class="kpi-parent-container">
    <ng-container *ngTemplateOutlet="kpiValue"></ng-container>
  </div>
}

<ng-template #kpiValue>
  <span class="kpi-title text-truncate">
    {{ kpiName }} ({{
      kpiMode === KpiMode.Week
        ? ('general.week_number_short_key' | translate) + weekNumber
        : ('datetime.monthShortNames.' + monthIndex | translate)
    }})
  </span>
  <div class="kpi-value">
    @if (!isLoadingKpiValue) {
      @if (kpiValueInMinutes !== null && kpiValueInMinutes !== undefined) {
        <div>
          <span class="kpi-text">
            {{ kpiValueInMinutes | minutesToHHmmDuration }}
          </span>
        </div>
      } @else {
        <span class="kpi-text" nzType="secondary">
          {{ 'general.n/a' | translate }}
        </span>
      }
    } @else {
      <div class="skeleton-loading">
        <nz-skeleton
          [nzActive]="true"
          [nzParagraph]="{ rows: 1 }"
          [nzTitle]="false"
        ></nz-skeleton>
      </div>
    }
  </div>
</ng-template>

<ng-template #tooltip>
  <span class="fw-normal">
    {{ kpiName }} ({{
      kpiMode === KpiMode.Week
        ? ('general.week_number_short_key' | translate) + weekNumber
        : ('datetime.monthShortNames.' + monthIndex | translate)
    }})
  </span>
  <span class="d-block"> {{ startDate() }} - {{ endDate() }} </span>
</ng-template>
